import {
  // GoogleMap,
  useJsApiLoader,
  // Marker as RGMMarker,
  // MarkerProps,
  // InfoBox,
  // MarkerClusterer,
} from "@react-google-maps/api";
// import { listServicePoints } from "api/query"; 

import { Helmet } from "react-helmet";
import React, { useEffect, useRef, useState, useContext, useMemo } from "react";
import { useCallback } from "react"; 
import { useNavigate, useParams } from "react-router";
import styles from "./index.module.scss";
// import { Link } from 'react-router-dom';
import { useLocation } from "react-router-dom";

// import QrReader from "libraries/react-qr-reader";
import QrReader from 'react-qr-reader';

// import BarcodeScannerComponent from 'react-qr-barcode-scanner';
import { useAuth } from "context/Auth";

import Dialog from "components/Dialog";
// import { ReactComponent as ResultSVG } from 'assets/result.svg';
import { ReactComponent as ArrowSVG } from "assets/icon-arrow-right.svg";
// import { ReactComponent as ShopSVG } from "assets/icon-shop.svg";
// import { ReactComponent as TipSVG } from "assets/image-return.svg";
import { ReactComponent as ReturnBoxSVG } from "assets/image-return-box.svg";
import { ReactComponent as ReturnStaffSVG } from "assets/image-return-staff.svg";
import { ReactComponent as SponserStarSVG } from "assets/sponsor-star.svg";

import FamiPackagePNG from "assets/fami_package.png";
import SponserAcerPNG from "assets/sponsor-acer2.png"; 
import SponserDBSPNG from "assets/sponsor-dbs2.png"; 

import LIFF20GIF from "assets/LIFF20GIF.gif";
import CouponTutorialImg from "assets/coupon-tutorial.jpg";
import Stepper from "./stepper";
// import { useAuth } from 'context/Auth';
import { ServicePointsData } from "api/query";
import { saveUserRentLogs, Logs1Message, saveGuestRentLogs, buildReturnPlace, duplicateReturnMessage } from "api/return";
import { getChannelStoreBySC, QRCode1ApiData } from "api/return";
import { getEpkType, QRCode2ApiData } from "api/return";
import { chkEpkId, bindUserRentLog } from "api/return";
import { logCameraError } from "api/clientLog";
import liff from "@line/liff";
import { GlobalContext } from "../../storage";
import ManualModal from "./manualModal";
import ManualModalNoGPS from "./manualModalNoGPS";
import ManualError from "./manualError";
import ReturnPointPicker from "./returnPointPicker";
import ReturnCompleteDialog from "./returnCompleteDialog";
import ReturnCompleteAnimation from "./returnCompleteAnimation";
import FamiReturnQrc from "./FamiReturnQrc";
import ReturnFlowNotice, {
  hasSeenReturnFlowNotice,
  isMidReturnFlow,
  markReturnFlowNoticeSeen,
} from "./returnFlowNotice";
import { simulateFmeReturnship, sendFmeClaimGuide } from "api/fmeReturnship";
import { LINE_OFFICIAL_URL, LIFF_COUPON_CLAIM_URL } from "constants/externalLinks";

// 只在測試站/本機顯示測試工具按鈕(正式網域不含 stage);後端 simulate endpoint 另有正式環境防呆
const IS_TEST_SITE =
  typeof window !== "undefined" &&
  (window.location.hostname.includes("stage") ||
    window.location.hostname.includes("localhost"));
// import { BrowserMultiFormatReader, IScannerControls } from '@zxing/browser';

// @types/react-qr-reader 未宣告 constraints prop；cast 讓 JSX 可傳入
const QrReaderAny = QrReader as React.ComponentType<any>;

const Return = () => {
  const { accessToken, me } = useAuth(); // 21.12.10 SCH (wilson 移到最前面)
  /* eslint-disable */
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDBfUhuri4U29ygEqlbyQeL7D5GvvaO0QA",
  }); 

  const { nearByStorage } = useContext(GlobalContext);
  const { setMeLatitude, setMeLongitude } = nearByStorage;
  const { me_latitude, me_longitude } = nearByStorage;
  const { channels, setChannels } = nearByStorage;
  const { spAreaAry, setSpAreaAry } = nearByStorage;
  const { chkDistance } = nearByStorage;
  const { is_area, setIsArea } = nearByStorage;
  const { gps_tage, setGpsTage } = nearByStorage; 
  const { setFamiMeLatitude, setFamiMeLongitude } = nearByStorage; 
  const { fami_me_latitude, fami_me_longitude } = nearByStorage; 
  const { fami_from, setFamiFrom } = nearByStorage; 
  
  // const vipURL = process.env.REACT_APP_VIP_URL; 
  const [step, setStep] = useState<number>(0);
  const [errorCheck, setErrorCheck] = useState<number>(0);
  // errorCheck=3 時顯示的具體錯誤來源(API + HTTP status + message),方便除錯
  // 相機錯誤觸發時的 LIFF / LINE-IAB 環境快照(供 ManualError 分流文案用)
  const [manualErrorIsInLiff, setManualErrorIsInLiff] = useState<boolean>(false);
  const [manualErrorInLineApp, setManualErrorInLineApp] = useState<boolean>(false);
  // PG-188 相機錯誤時的手動逃生口類型(見 manualError.tsx):
  //   'package'(全家/已選點→輸包裝編號)、'pickPoint'(非全家 step0→GPS 選歸還點)、undefined(無)
  const [manualErrorMode, setManualErrorMode] = useState<'package' | 'pickPoint' | undefined>(undefined);
  // PG-188 非全家「手動選擇歸還點」的 GPS 清單 Modal 開關
  const [returnPointPickerVisible, setReturnPointPickerVisible] = useState<boolean>(false);
  // 新版歸還流程教學彈窗:LINE 圖文選單 / 立牌 QR 是直接落在 /return,不會經過 /rent,
  // 所以這裡也要擋一次(同 session 已看過就跳過)
  const [flowNoticeVisible, setFlowNoticeVisible] = useState<boolean>(
    () => !hasSeenReturnFlowNotice() && !isMidReturnFlow()
  );
  // 彈窗蓋著時相機仍在背景運作,用 ref 擋掉掃描回呼,避免使用者還在看教學就被自動帶進下一步
  const flowNoticeOpenRef = useRef<boolean>(!hasSeenReturnFlowNotice() && !isMidReturnFlow());

  // 把 axios error 萃取成可讀文字進 console(不顯示給使用者),格式:[API 名] status: message
  const formatApiError = (api: string, e: any): string => {
    const status = e?.response?.status ?? 'no-response';
    const body = e?.response?.data;
    const msg = body?.message || body?.errors || e?.message || 'unknown';
    const msgStr = typeof msg === 'string' ? msg : JSON.stringify(msg);
    return `[${api}] ${status}: ${msgStr}`;
  };
  const [stopScan, setStopScan] = useState<boolean>(false);
  const [remindVisible, setRemindVisible] = useState<boolean>(false);//自己還幫人環提醒
  // 訪客歸還前的二次確認 dialog(momo 免登入 / 非 momo LIFF-bind 都走這個)
  // Lynn 要求:會員已有 remindVisible 包裝編號確認,訪客也要比照、避免掃錯包裝就直接建歸還紀錄
  const [guestConfirmVisible, setGuestConfirmVisible] = useState<boolean>(false);
  const [detailVisible, setDetailVisible] = useState<boolean>(false);//包裝歸還明細
  const [repeatVisible, setRepeatVisible] = useState<boolean>(false);//重複歸還提醒
  const [famiSimDoneVisible, setFamiSimDoneVisible] = useState<boolean>(false); // 測試站模擬交件完成提示
  const [manualVisible, setManualVisible] = useState<boolean>(false);//歸還全家下拉選單
  const [manualNoGPSVisible, setManualNoGPSVisible] = useState<boolean>(false); // 歸還全家下拉選單(無GPS)
  const [manualErrorVisible, setManualErrorVisible] = useState<boolean>(false); // 授權提示
  const [currentLocationlVisible, setCurrentLocationVisible] = useState<boolean>(false);//確認掃描包裝編號
  const [done, setDone] = useState<boolean>(false);//確認包裝投進歸還箱
  // 歸還類別： 歸還箱 or 店員
  const [returnType, setReturnType] = useState<"box" | "staff">("box");
  const [sponsor, setSponsor] = useState<boolean>(false); // 贊助開關
  const [srandom, setSrandom] = useState<number>(0); // 贊助切換
  // PG-186 全家歸還單 id:要號時帶給退貨通訂單,讓後端能以此判斷「B02 交件確認後才可領券」
  const [famiRentalLogId, setFamiRentalLogId] = useState<number | undefined>(undefined);
  // PG-209 重掃同一顆包裝:後端回稍早那筆,QRC 畫面要說明這是同一組編號
  const [famiIsRescan, setFamiIsRescan] = useState<boolean>(false);
  const [mess, setMess] = useState<string>(''); // 贊助切換
  // 歸還成功後的共用彈窗（momo 免登入 / 會員登入皆共用）
  const [returnCompleteVisible, setReturnCompleteVisible] = useState<boolean>(false);
  // PG-92 r3: 帶到 ReturnCompleteDialog 後接到 LIFF URL query。
  // localStorage 在 LINE app 內 webview 與外部 Safari 不互通,單靠 localStorage
  // 跨 webview 領券會失敗(Lynn 04/30 13:55 momo 流程 prod 重現,log 68591 沒人領)。
  // PG-56 新版後端:momo/訪客綁定改用 claim_token(uuid 字串),取代舊版數字 log id
  const [pendingRentLogId, setPendingRentLogId] = useState<string | null>(null);

  const location = useLocation();
  const navigate = useNavigate();
  const { state, pathname } = useLocation();
  // Route.path=":salesChannel/:storeId"; 
  const { salesChannel, storeId } = useParams();
  const { shortUrl } = useParams(); 
  // 通路代號 Ref
  const salesChannelRef = useRef<string>();
  // 商店代號 Ref
  const storeIdRef = useRef<string>();
  // 包裝代號 Ref
  const packageIdRef = useRef<string>();
  // lihi-shortUrl Ref
  const shortUrlRef = useRef<string>();
  // channel_id / svpt_id ref：fetchChannelStoreBySC 設好後給 handlePackageFound 同步讀取,
  // 避免用 state 時被 closure 捕捉到舊值(導致 saveGuestRentLogs 打出空 chs_id/svpt_id → 422 → 落到 liff.login())
  const channelIdRef = useRef<number>();
  const svptIdRef = useRef<string | number>();
  
  // const { accessToken, me } = useAuth();
  const [channelStores, setChannelStores] = useState<QRCode1ApiData>();
  const [epkType, setEpkType] = useState<QRCode2ApiData>();
  const [userRentLogs, setUserRentLogs] = useState<Logs1Message>();
  // momo 包裝（customer='momo'）旗標，掃描後由 chkEpkId 回傳決定
  const customerRef = useRef<string | null>(null);
  const { returnStorage } = useContext(GlobalContext);
  const { channel_name, setChannelName } = returnStorage;
  const { channel_id, setChannelId } = returnStorage;
  const { use_type, setUseType } = returnStorage; 
  const { store_id, setStoreId } = returnStorage; 
  const { chs_short_code, setChsShortCode } = returnStorage; 
  const { svpt_name, setSvPtName } = returnStorage;
  const { svpt_id, setSvPtId } = returnStorage;
  const { epk_id, setEpkId } = returnStorage;
  const { type_name, setTypeName } = returnStorage;
  const { date_time, setDateTime } = returnStorage;
  const { renter_id, setRenterId } = returnStorage;
  const { fami_tage, setFamiTage } = returnStorage; 

  const [servicePoints, setServicePoints] = useState<ServicePointsData[]>([]); 

  const mapRef = useRef<google.maps.Map>();

  const stepRef = useRef<number>(0);
  const errorCheckRef = useRef<number>(0);
  const positionCheckRef = useRef<number>(0); // 20230120 wilson add 定位資料 0：沒啟動 , 1: 有啟動

  const [epkIdFound, setEpkIdFound] = useState<boolean>(false);
  const epkId = useRef<string>(); // 22.02.09 SCH

  const [gpsCheck, setGpsCheck] = useState<boolean>(false);


  const [shouldRenderCamera, setShouldRenderCamera] = useState(false);
  const [cameraRetrying, setCameraRetrying] = useState(false);
  const cameraRetryCountRef = useRef(0);

  // LINE OAuth redirect 會讓整個 tab 被 reload，React state 全部消失。
  // 在 liff.login() 前我們把已掃描的包裝編號+必要欄位寫進 sessionStorage，
  // 登入返回後由下方 useEffect 還原，使用者不必重新掃描。
  const PENDING_SCAN_KEY = 'pending_return_scan';
  // 非 momo 的新流程：外部瀏覽器掃完後建匿名 log，透過 LIFF URL query params
  // (?pendingRentLog=X&fromGuest=1) 帶到 LINE app 內。
  // sessionStorage 跨不過 LINE app 的 webview 邊界，URL 可以。
  //
  // 這兩個值刻意「每次 render 重算」而不是 useState initializer 只算一次:
  // LIFF 從 liff.state 導到真網址、或 bind 完成後 replaceState 清掉參數,
  // 網址都會在元件活著的時候改變。只算一次的話,從 LINE 回來的那次會讀到還沒導轉的網址,
  // 使用者就被當成全新的一輪歸還、要求重掃包裝。
  const locationSearch = useLocation().search;
  const pendingFromUrl = useMemo<{ rentLogId: string | null; fromGuest: boolean }>(() => {
    try {
      const p = new URLSearchParams(locationSearch || window.location.search);
      const rentLogStr = p.get('pendingRentLog');

      return {
        // claim_token(uuid 字串),不再 Number()
        rentLogId: rentLogStr || null,
        fromGuest: p.get('fromGuest') === '1',
      };
    } catch {
      return { rentLogId: null, fromGuest: false };
    }
  }, [locationSearch]);
  // 綁定完成會把 pendingRentLog 從網址上清掉,這裡要記得「這一輪本來就是帶著參數進來的」,
  // 否則相機會在動畫播完之後又被 render 出來。
  const hadPendingRef = useRef<boolean>(false);
  if (pendingFromUrl.rentLogId) hadPendingRef.current = true;
  const hasPendingScan = useMemo<boolean>(() => {
    if (hadPendingRef.current) return true;
    try {
      if (sessionStorage.getItem(PENDING_SCAN_KEY)) return true;
    } catch {
      /* ignore */
    }

    return false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationSearch, pendingFromUrl.rentLogId]);
  // 綁定完成後用來播「歸還完成」過場動畫的 flag
  const [returnJustCompletedVisible, setReturnJustCompletedVisible] = useState<boolean>(false);
  // 非 momo guest 掃描成功後要跳 LIFF 的 URL。
  // 不直接 window.location.href 而是 render 一個按鈕讓使用者自己點,原因:
  // iOS Universal Link 只在「使用者手勢同步觸發」的 navigation 才會跳 LINE app;
  // 從 QR onScan 的 async callback 觸發會被 iOS 當一般網頁開、不跳 app,導致使用者卡在 liff.line.me → endpoint redirect 無 session 的空白頁。
  const [pendingLineBind, setPendingLineBind] = useState<{
    url: string;
    rentLogId: number;
    targetPath: string;
  } | null>(null);
  // 來源通路（?from=fami）：影響 step 0 掃失敗時要不要顯示「無法掃描請點我」按鈕
  //   - 全家 (fromFami=true)：顯示（點了彈全家店家下拉選單當逃生出口）
  //   - 其他通路 (fromFami=false)：不顯示（沒有手動替代路徑）
  const [fromFami] = useState<boolean>(() => {
    try {
      return new URLSearchParams(window.location.search).get('from') === 'fami';
    } catch {
      return false;
    }
  });

  /* eslint-enable */

  // 預先下載領券 dialog 裡那張教學圖 (coupon-tutorial.jpg):
  // dialog 開啟時瀏覽器才抓圖的話會延遲幾秒才出,Lynn 同仁測試時先看到沒圖版本、
  // 後看到有圖版本,誤以為是兩個不同 dialog 回報 bug。
  // 進到 Return 頁(掃店家/掃包裝過程至少 5-10 秒)就背景預載,等 dialog 顯示時圖已在快取。
  useEffect(() => {
    const img = new Image();
    img.src = CouponTutorialImg;
  }, []);

  // 執行 GPS 自動定位功能 auto center map base on user's geolocation
  // const getLocation = useCallback(() => {
  const getLocation = useCallback(() => {
    // console.log('getLocation');
    if (!navigator.geolocation) {
      // setStatus('您的瀏覽器並未支援 GPS 自動定位功能。');
      setGpsTage(false);
      setGpsCheck(false);
    } else {
      // setStatus('正在偵測您的位置...');

      // navigator.geolocation.getCurrentPosition(
      const watchId = navigator.geolocation.watchPosition(
        (position) => {

          mapRef?.current?.setCenter({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
          mapRef?.current?.setZoom(16);
          // setDefaultProps({
          //   center: {
          //     lat: position.coords.latitude,
          //     lng: position.coords.longitude,
          //   },
          //   zoom: 16,
          // });
          // Saved to storage
          setFamiMeLatitude(position.coords.latitude);
          setFamiMeLongitude(position.coords.longitude);
          setGpsTage(true);
          setGpsCheck(true);
          navigator.geolocation.clearWatch(watchId);
          // 20230120 wilson add 定位資料 0：沒啟動 , 1: 有啟動
          positionCheckRef.current = 1;

          setFamiFrom(Math.random()); // 隨機數，讓全家能自動抓取最近店家
        },
        (error) => {
          setGpsTage(false);
          setGpsCheck(false);
          switch (error.code) {
            case error.PERMISSION_DENIED:
              console.log(
                "wilson geolocation error",
                "用戶拒絕對獲取地理位置的請求。"
              );
              break;
            case error.POSITION_UNAVAILABLE:
              console.log("wilson geolocation error", "位置信息是不可用的。");
              break;
            case error.TIMEOUT:
              console.log("wilson geolocation error", "請求用戶地理位置超時。");
              break;
            default:
              console.log("wilson geolocation error", "未知錯誤。");
              break;
          }
          // setStatus('無法取得您的所在位置');
          // 20230112 wilson add  1: camera , 2:position
          //暫時先這樣
          // errorCheckRef.current = 2;
          // setErrorCheck(2);
          // setManualErrorVisible(true);

          // 20230120 wilson add 定位資料 0：沒啟動 , 1: 有啟動
          positionCheckRef.current = 0;
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // 延遲載入 QrReader
    const timer = setTimeout(() => {
      setShouldRenderCamera(true);
    }, 1000); // 給予 500ms 緩衝
    return () => clearTimeout(timer);
  }, []);

  // step 變更時把頁面捲回頂端:
  // 從 step 0 → 1 會關閉「您目前在 XX」Dialog,iOS Safari 在 MUI Dialog
  // scroll-lock 解除後有機率維持舊 scrollTop,造成 step2 畫面整個往上偏。
  // requestAnimationFrame 等 layout settle 後再捲,避免被後續重繪蓋掉。
  useEffect(() => {
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    });
  }, [step]);

  // 若來源是「全家」(?from=fami)：只設 famiFrom，不在進頁面就 getLocation()。
  // iOS 上 GPS 權限彈窗與相機 getUserMedia 同時觸發會互相干擾，導致相機畫面空白；
  // 改成等使用者點「無法掃描請點我」打開 ManualModal 時才抓 GPS。
  useEffect(() => {
    if (fromFami) {
      setFamiFrom(Math.random());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromFami]);

  // iOS Safari 100vh / 100dvh 在浮動底部工具列出現時都不可靠：
  // 100vh 不扣工具列、100dvh 在某些版本還是會抓錯。
  // 用 JS 把 window.innerHeight (一定是當前可視高度) 寫進 --vh，
  // CSS 用 calc(var(--vh) * 100) 算出 100% 視窗高，按鈕保證在可視範圍內。
  useEffect(() => {
    const setVh = () => {
      document.documentElement.style.setProperty(
        '--vh',
        `${window.innerHeight * 0.01}px`
      );
    };
    setVh();
    window.addEventListener('resize', setVh);
    window.addEventListener('orientationchange', setVh);
    return () => {
      window.removeEventListener('resize', setVh);
      window.removeEventListener('orientationchange', setVh);
    };
  }, []);
  
  useEffect(() => {
    return () => {
      setStopScan(false);
      // setShouldRenderCamera(false); // unmount 時重置
    };
  }, []);

  useEffect(() => {
    // 未登入（momo 免登入流程等待掃描）時不需要 renter_id
    if (!accessToken) {
      return;
    }
    // 小白 未從輸入電話頁進來，則抓 me.id，否則抓改變的 renter_id
    if (!state) {
      setRenterId(me?.id!);
    }
    // eslint-disable-next-line
  }, [pathname, me?.id]);

  // 從全家歸還地圖「返回歸還」帶 ?resume=1 回來:用先前存的包裝編號直接還原寄件 QRC,不重掃、不重跑流程
  useEffect(() => {
    if (new URLSearchParams(window.location.search).get('resume') !== '1') return;
    let savedEpk = '';
    try {
      savedEpk = sessionStorage.getItem('fami_resume_epk') || '';
    } catch {
      savedEpk = '';
    }
    if (!savedEpk) return;
    setEpkId(savedEpk);
    packageIdRef.current = savedEpk;
    epkId.current = savedEpk;
    salesChannelRef.current = 'fami';
    storeIdRef.current = 'fami99999';
    setFamiTage(true);
    setStopScan(true);
    stepRef.current = 2;
    setStep(2);
    setManualVisible(false);
    setManualNoGPSVisible(false);
    setDone(true); // → done + fami_tage → FamiReturnQrc 重新顯示寄件 QRC(要號冪等,回同一張)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // resume 還原時不要再跑全家初始化(否則會把 step 推回掃描/重跑)
    if (new URLSearchParams(window.location.search).get('resume') === '1') return;
    // 讓本段程序先停留(2.5)秒後再執行{...}！
    // setTimeout(() => {

    // 啟動全家 Fami port 分流 透過 get parameter
    if (storeId === "fami99999") {
      setFamiFrom(Math.random()); // 隨機數，讓全家能自動抓取最近店家

      // PG-56 全家「要號-first」(對齊日翊退貨通):全家不掃歸還點 QR。
      // 選全家即預設全家通路(取 channel_id/svpt_id + fami_tage),直接進包裝掃描;
      // 掃完包裝歸還完成後,fami_tage 觸發 FamiReturnQrc 向日翊要號、顯示寄件編號 QR。
      if (!hasPendingScan) {
        salesChannelRef.current = 'fami';
        storeIdRef.current = 'fami99999';
        fetchChannelStoreBySC(true); // 靜音:全家不彈「您目前在」門市確認
        stepRef.current = 1;
        setStep(1);
      }
    }

    if (salesChannel && storeId && storeId !== "fami99999") {
      storeIdRef.current = storeId;
      salesChannelRef.current = salesChannel;
      // useEffect()因移除dependencies而[]有兩條黃色底線(OK啦)
      fetchChannelStoreBySC();
      if (!hasPendingScan) {
        stepRef.current = 1;
        setStep(1);
      }
    } else if (chs_short_code && store_id) {
      storeIdRef.current = store_id;
      salesChannelRef.current = chs_short_code;
      // useEffect()因移除dependencies而[]有兩條黃色底線(OK啦)
      fetchChannelStoreBySC();
      if (!hasPendingScan) {
        stepRef.current = 1;
        setStep(1);
      }
    }

    // }, 1500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me?.id]);

  // By Lihi shortUrl 或 salesChannel + storeId 找出 ServicePoint, 二擇一！
  useEffect(() => {
    // 這一段不會被執行, 因為 Lihi shortUrl 會自動轉為 liff.line.me 網址
    // 所以上面 useEffect() 的 if (salesChannel && storeId) {} 會為 true 並且搶先執行
    if (shortUrl) {
      // 版面會多出一個外框！已不使用！
      shortUrlRef.current = shortUrl; 
      // useEffect()因移除dependencies而[]有兩條黃色底線(OK啦)
      fetchChannelStoreBySC(); 
      stepRef.current = 1; 
      setStep(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 非 momo 新流程返回：LIFF URL query 帶 pendingRentLog=X 進來 → 自動 bind + 播動畫 + 彈領券對話框
  // 跟 sessionStorage 那條路互斥（URL 有 param 的話優先走這條）。
  useEffect(() => {
    if (!accessToken) return;
    if (!pendingFromUrl.rentLogId) return;

    let cancelled = false;

    (async () => {
      // 同步寫 localStorage 給 /discount/ecommerce 接手（user 點「領取優惠券」時會用到）
      try {
        localStorage.setItem(
          'pending_coupon_claim',
          JSON.stringify({
            user_rent_log_id: pendingFromUrl.rentLogId,
            created_at: Date.now(),
          })
        );
      } catch (err) {
        console.log('localStorage write failed', err);
      }
      setPendingRentLogId(pendingFromUrl.rentLogId);

      // 呼叫 bindUserRentLog(X, []) 只做綁定、不領券
      // 後續使用者點「領取優惠券」進 /discount/ecommerce 時會再呼叫 bindUserRentLog(X, [couponIds]) 完成領券
      try {
        await bindUserRentLog(accessToken, [pendingFromUrl.rentLogId!], []);
      } catch (e) {
        console.log('bindUserRentLog (no coupons) failed', e);
        // 不 block 使用者 → 即便綁定失敗，進 /discount/ecommerce 時會再試一次
      }

      if (cancelled) return;

      // 清 URL 避免重新整理再次觸發 bind
      try {
        const url = new URL(window.location.href);
        url.searchParams.delete('pendingRentLog');
        url.searchParams.delete('fromGuest');
        const newSearch = url.searchParams.toString();
        const newUrl = url.pathname + (newSearch ? `?${newSearch}` : '');
        window.history.replaceState({}, '', newUrl);
      } catch {
        /* ignore */
      }

      // bind 成功 → 清 sessionStorage,避免 fallback useEffect 再誤觸發救援按鈕
      try { sessionStorage.removeItem('pending_line_bind'); } catch { /* ignore */ }

      // 進入「歸還完成」過場動畫，2 秒後由 ReturnCompleteAnimation 的 onFinish 彈領券 Dialog
      setReturnJustCompletedVisible(true);
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, pendingFromUrl.rentLogId]);

  // 救援按鈕:使用者從 liff.line.me redirect 回來但沒 LIFF session 的情境。
  //
  // 顯示條件(三重防誤觸發):
  //   1. sessionStorage pending_line_bind 存在(CTA 按下時才寫,見下方 onClick)
  //   2. sessionStorage.targetPath 跟當前 pathname 完全相符 — 避免使用者從 A 店歸還流程的殘留
  //      跑到 B 店流程誤彈救援按鈕
  //   3. created_at 3 分鐘內(liff → access.line.me → 回來通常 30 秒內搞定,超過一定是殘留)
  //   + accessToken 還沒到(已登入就不需救援)
  //
  // 按鈕 onClick 同步呼叫 liff.login({redirectUri: 重建含 pendingRentLog 的 URL}),
  // 走 access.line.me 手動登入,回來 URL 帶 query → 觸發原本 URL-path 的 bind useEffect 完成綁定。
  //
  // 為什麼不做 sessionStorage-based auto-bind:之前版本有做,造成嚴重 bug —
  // 使用者進另一條歸還流程時,accessToken 因為其他原因到齊(比如 LINE OA 自動登入),
  // sessionStorage 裡的舊 rentLogId 就會被誤 bind → 直接跳歸還成功但根本沒掃包裝。
  // 只依賴 URL query 做 bind,才能保證「這一次登入是為了 bind 這一筆」的強關聯。
  const [showLoginFallback, setShowLoginFallback] = useState(false);
  const [fallbackRentLogId, setFallbackRentLogId] = useState<number | null>(null);
  const [fallbackTargetPath, setFallbackTargetPath] = useState<string>('/return');
  useEffect(() => {
    if (accessToken) return;

    let pending: { rentLogId: number; targetPath: string; created_at: number } | null = null;
    try {
      const raw = sessionStorage.getItem('pending_line_bind');
      if (raw) pending = JSON.parse(raw);
    } catch {
      /* ignore parse error */
    }
    if (!pending) return;

    // 3 分鐘過期 — 正常 LIFF 來回 + 手動登入不會拖這麼久,超過就視為殘留清掉
    if (Date.now() - pending.created_at > 3 * 60 * 1000) {
      try { sessionStorage.removeItem('pending_line_bind'); } catch { /* ignore */ }
      return;
    }

    // path 不符:使用者進入的是另一條歸還流程 — 一定不是從同一個 CTA 按鈕 redirect 回來
    // (直接清掉,避免新流程掃到包裝時又被舊紀錄誤觸發)
    if (pending.targetPath !== window.location.pathname) {
      try { sessionStorage.removeItem('pending_line_bind'); } catch { /* ignore */ }
      return;
    }

    // 2s 延遲:給 Safari/LINE webview 自動 flush accessToken 的時間
    const timer = setTimeout(() => {
      setFallbackRentLogId(pending!.rentLogId);
      setFallbackTargetPath(pending!.targetPath);
      setShowLoginFallback(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, [accessToken]);

  // LINE OAuth 返回後：若 sessionStorage 有 pending scan，直接還原到 step 2 + 觸發會員歸還流程。
  // 依賴 accessToken：Auth context 會在 Login API 成功後 setAccessToken，此時這個 effect 才跑。
  useEffect(() => {
    if (!accessToken) return;
    if (!hasPendingScan) return;
    // URL param restore 會自行處理，不要跟 sessionStorage 搶
    if (pendingFromUrl.rentLogId) return;

    let raw: string | null = null;
    try {
      raw = sessionStorage.getItem(PENDING_SCAN_KEY);
    } catch {
      /* ignore */
    }
    if (!raw) return;
    let pending: any = null;
    try {
      pending = JSON.parse(raw);
    } catch {
      return;
    }
    try {
      sessionStorage.removeItem(PENDING_SCAN_KEY);
    } catch {
      /* ignore */
    }
    if (!pending?.epkId) return;

    epkId.current = pending.epkId;
    packageIdRef.current = pending.epkId;
    customerRef.current = pending.customer ?? null;
    setEpkId(pending.epkId);
    if (pending.storeId) storeIdRef.current = pending.storeId;
    if (pending.salesChannel) salesChannelRef.current = pending.salesChannel;

    // 先把 stepRef 推到 2，再 fetch（fetchChannelStoreBySC 會用 stepRef 判斷是否重彈
    // 「您目前在 XX」Dialog，避免 LIFF 登入返回後重複提示）
    stepRef.current = 2;
    setStep(2);
    setStopScan(true);
    setRemindVisible(true);
    fetchChannelStoreBySC();
    fetchEpkType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);

  /**
   * 通路是否已查到。
   *
   * channel_id 用 null 判斷而不是 truthiness:新後端 return_channels 只映射 fami,
   * 其餘通路一律落 default 的 channel_id=0,truthiness 會把「查到了,是預設通路」
   * 誤判成「沒查到」→ 提早 return → 手動輸入框關不掉的無限 loop。
   * channel_id 新後端並未收(歸還只送 return_location_id),它在這裡純粹是前端閘門。
   * svpt_id 相反,是 return_location_id 的來源,空字串就是真的不能送。
   */
  const channelResolved = (): boolean =>
    channelIdRef.current != null && !!svptIdRef.current;

  const fetchChannelStoreBySC = async (silent = false): Promise<boolean> => {
    // 沒有通路代號就不要發請求:chs_short_code 是後端必填,送空的必定 422,
    // 而錯誤會被吞成「參數錯誤」對話框,使用者看不懂也無從恢復。
    // 舊版正式站的 log 顯示這種空參數請求佔本 API 呼叫量約四成(每天 130-150 次),
    // 來源是多條「通路還沒查到就先打」的路徑,擋在這裡可以一次涵蓋全部呼叫點。
    if (!salesChannelRef.current) {
      console.warn('[fetchChannelStoreBySC] 略過:尚未取得通路代號');
      return false;
    }

    try {
      const { data } = await getChannelStoreBySC(accessToken!, 1, {
        chs_short_code: salesChannelRef.current,
        store_id: storeIdRef.current,
        lihi_url: shortUrlRef.current,
      });
      setChannelStores(data);
      // 將資料存入到 storage !!
      setChannelName(data?.channel_name);
      setChannelId(data?.channel_id);
      setUseType(data?.use_type);
      setSvPtName(data?.svpt_name);
      setSvPtId(data?.svpt_id);
      channelIdRef.current = data?.channel_id ?? undefined;
      svptIdRef.current = data?.svpt_id;
      // possible set return type here ?
      setReturnType(data?.return_type!); 

      if (data?.chs_short_code === "fami") {
        setFamiTage(true);
      }

      setStoreId(storeIdRef.current);
      setChsShortCode(salesChannelRef.current); 
      
      // 掃到歸還點後彈「您目前在 XX」讓使用者目視確認（QR 可能事先轉寄，需要人工核對店名）
      // Issue 6：LIFF restore 路徑已將 stepRef 推到 2，這裡 skip 以避免重複提示。
      if (data && stepRef.current !== 2) {
        // 全家要號-first:不綁定門市(要號後任選店交件),任何路徑都不彈「您目前在」。
        // 手動輸入(onManualConfirm)呼叫的是非靜音版,少了這層 fami 判斷會讓全家彈窗與輸入互相打架成無限 loop。
        const isFami = data?.chs_short_code === "fami";
        if ((state && state.phone) || isFami) {
          setCurrentLocationVisible(false);
        } else {
          setCurrentLocationVisible(!silent);
        }
      }

      return channelResolved();
    } catch (e: any) {
      console.log(e);
      console.error(formatApiError('getChannelStoreBySC', e));
      setManualErrorVisible(true)
      setErrorCheck(3)
      return false;
    }
  };

  const fetchEpkType = async () => {
    try {
      const { data } = await getEpkType(accessToken!, 1, {
        epk_id: packageIdRef.current,
      });
      setEpkType(data);
      setEpkId(packageIdRef.current);
      setTypeName(data?.type_name);
      setDateTime(data?.date_time);
    } catch (e: any) {
      console.log(e);
      console.error(formatApiError('getEpkType', e));
      setManualErrorVisible(true)
      setErrorCheck(3)
    }
  };

  /**
   * 歸還時要一併回報的「哪個通路的哪家門市」。
   *
   * 後端的 return_location_id 只落得到 tb_locations,通路門市查不到就 fallback 到主倉庫,
   * 後台歸還紀錄看不出實際收件門市;這兩欄補上那一欄。
   *
   * 一律優先讀 ref:state 在 handleScan → findEpkId → 送出的同一個 microtask 序裡可能還沒 flush。
   * 空值與全家 placeholder 的過濾規則在 buildReturnPlace 裡。
   */
  const returnPlace = () =>
    buildReturnPlace(
      salesChannelRef.current || chs_short_code,
      storeIdRef.current || store_id
    );

  const addGuestRentLogs = async () => {
    try {
      const { data: _data } = await saveGuestRentLogs({
        epk_id: epkId.current,
        chs_id: channel_id,
        svpt_id: svpt_id,
        ...returnPlace(),
      });
      // 記下 claim_token 供稍後會員登入時事後綁定發點
      const userRentLogId = (_data as any)?.data?.claim_token;
      if (userRentLogId) {
        try {
          localStorage.setItem(
            'pending_coupon_claim',
            JSON.stringify({
              user_rent_log_id: userRentLogId,
              created_at: Date.now(),
            })
          );
        } catch (err) {
          console.log('localStorage write failed', err);
        }
        setPendingRentLogId(userRentLogId);
      }
      // momo 免登入歸還 → 先播 2s「歸還完成」綠勾勾動畫,讓使用者明確看到成功,
      // 動畫結束後 onFinish 才彈領券 dialog。對齊非 momo LIFF-bind / 會員路徑的節奏,
      // 避免 dialog 一閃而過使用者來不及看清楚已歸還成功 (Lynn 回饋 DDC momo 會跳太快)。
      setReturnJustCompletedVisible(true);
    }catch (e: any) {
      console.log(e);
      const err = e.response?.data?.errors;
      setManualErrorVisible(true)
      if(err === 'Returned twice on the same day.'){
        setErrorCheck(5)
        return
      }
      console.error(formatApiError('saveGuestRentLogs', e));
      setErrorCheck(3)
    }
  }

  const addUserRentLogs = async () => {
    try {
      const { data } = await saveUserRentLogs(accessToken!, 1, {
        // 掃碼當下 epk_id state 還沒更新,拿 ref 才是剛掃到的編號(state 空 → 後端 422 required)
        epk_id: epkId.current || epk_id,
        renter_id: renter_id,
        return_user_id: me?.id!, 
        chs_id: channel_id,
        svpt_id: svpt_id,
        return_type: 0,
        ...returnPlace(),
      });
      setUserRentLogs(data);
      
      // if (state && state.phone && detailVisible) {
      if (state && state.phone ) {

        //小白加
        if(data?.success){
          setDetailVisible(true);
          setStep(2);
        }else{
          if(data?.message === 'Return frequency is too high.'){
            setMess('若您取得多個同包裝編號的循環包裝，請稍候一分鐘再試。');
          }else if(data?.message === 'The number of returns exceeds three times.'){
            setMess('同包裝編號的循環包裝歸還次數超過上限，請隔日歸還。');
          }else{
            setMess('您輸入的包裝編號已在系統中成功歸還，請將包裝交給店員或投入歸還箱。');
          }
          setRepeatVisible(true);
        }

      }else{
        //判斷是否一分鐘內重複輸入同樣包裝編號或單一碼單日歸還超過三次
        if(data?.success){
          setDetailVisible(true);
        }else{
          if(data?.message === 'Return frequency is too high.'){
            setMess('若您取得多個同包裝編號的循環包裝，請稍候一分鐘再試。');
          }else if(data?.message === 'The number of returns exceeds three times.'){
            setMess('同包裝編號的循環包裝歸還次數超過上限，請隔日歸還。');
          }else{
            setMess('您輸入的包裝編號已在系統中成功歸還，請將包裝交給店員或投入歸還箱。');
          }
          setRepeatVisible(true);
        }
      }

    } catch (e: any) {
      console.log(e);
      // 重複歸還 / 單一碼次數與頻率限制:後端 409,adapter 已轉成舊版字串
      const dupMsg = duplicateReturnMessage(e?.response?.data?.errors);
      if (dupMsg) {
        setMess(dupMsg);
        setRepeatVisible(true);
        return;
      }
      console.error(formatApiError('saveUserRentLogs', e));
      setManualErrorVisible(true)
      setErrorCheck(3)
    }
  };

  useEffect(() => {
    if (state && state.epk_id) {
      setStopScan(true); // 21.12.22 SCH
      packageIdRef.current = epk_id;
    }
  }, [state, epk_id]);

  useEffect(() => {
    if (state && state.phone ) {
      // setStep(2);小白刪
      setStopScan(true); // 21.12.18 SCH
      // setDetailVisible(true);小白刪
      //小白加
      if(renter_id !== me?.id! && renter_id!== undefined){
        addUserRentLogs();
      }
      if(renter_id === me?.id! && renter_id!== undefined){
        addUserRentLogs();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state,renter_id]);
  
  useEffect(() => {
    if (state && state.phone && detailVisible) {
      setChannelStores({
        channel_name: channel_name,
        channel_id: channel_id,
        use_type: use_type, 
        svpt_name: svpt_name,
        svpt_id: svpt_id,
        chs_short_code: chs_short_code, 
        store_id: store_id, 
        return_type: returnType, 
      });
      packageIdRef.current = epk_id;
      setEpkType({
        type_name: type_name,
        date_time: date_time,
      });
    }
  }, [
    state,
    detailVisible,
    channel_name,
    channel_id,
    use_type,
    svpt_name,
    svpt_id,
    epk_id,
    type_name,
    date_time,
    renter_id,
    pathname,
    chs_short_code,
    store_id,
    returnType,
  ]);

  const onConfirm = () => {
    // 幫自己還
    addUserRentLogs(); // 21.12.10 SCH
    setRemindVisible(false);
    // setDetailVisible(true);小白刪
  };

  const onCancel = () => {
    // 幫別人還
    setRemindVisible(false);
    // 2021.12.10 Mike, 為lihi短網址直接進系統，修改路徑的寫法!!
    let nowPath = pathname;
    
    let words = nowPath.split("/");
    //小白加 重置renter_id
    setRenterId();
    if (words.length === 2) {
      navigate("./other");
    } else {
      if (words.length === 3) {
        navigate("other");
      }
      if (words.length === 4) {
        navigate("../other");
      }
      if (words.length === 5) {
        navigate("../../other");
      }
      if (words.length === 6) {
        navigate("../../../other");
      }
    }
  };



  const onDetailConfirm = () => {
    setStep(2);
    setDetailVisible(false);
    setDone(true);
    setSponsor(true);
    setSrandom(Math.floor(Math.random() * 2));
  };

  const findEpkId = async (): Promise<boolean> => {
    // 防禦:epkId.current 為空時後端會以 422 "The epk id field is required." 回應,
    // 使用者看到「參數錯誤」還被 dialog 導回 /rent,實際上是前端不該打這支
    if (!epkId.current) {
      console.error('[findEpkId] local: epk_id empty');
      setManualErrorVisible(true);
      setErrorCheck(7);
      return false;
    }
    try {
      // is_guest 保留相容（後端已忽略），customer 欄位會在回傳中帶回
      const { data } = await chkEpkId(accessToken!, 1, {
        epk_id: epkId.current, is_guest: 0
      });
      if (data) {
        setEpkId(data?.epk_id);
        customerRef.current = (data as any)?.customer ?? null;
        setEpkIdFound(true);
        return true;
      } else {
        customerRef.current = null;
        setEpkIdFound(false);
        return false;
      }
    } catch (e: any) {
      console.error(formatApiError('chkEpkId', e));
      const error = e.response?.data?.errors;
      setManualErrorVisible(true)
      if(error === 'Package in wrong method.'){
        setErrorCheck(4)
        return false;
      }
      // 404 = 後端查無此包裝編號(可能掃到未入庫的樣品/印刷箱),給明確指引而非技術錯誤
      if (e?.response?.status === 404) {
        setErrorCheck(8);
        return false;
      }
      setErrorCheck(3)
      return false;
    }
  };

  /**
   * 包裝掃描成功後的分流(訪客,會員已在 handlePackageFound 內 return)：
   *  - customer='momo' → 免登入歸還(addGuestRentLogs)
   *  - customer=null → LIFF-bind 新流程(建匿名 log + 中繼按鈕跳 LINE app)
   *
   * 由「確認歸還」dialog 的 onConfirm 呼叫 — 使用者在 dialog 按下確認才會真的送 API,
   * 避免掃錯包裝就直接建歸還紀錄(Lynn 4/24 需求:訪客也要有包裝編號二次確認)。
   */
  const executeGuestReturn = async () => {
    const isMomo = customerRef.current === 'momo';

    if (isMomo) {
      // momo 免登入歸還
      setStopScan(true);
      await addGuestRentLogs();
      return;
    }

    // 非 momo 新流程 (2026-04 單一入口改版後)：
    //  1. 外部瀏覽器就先建匿名 user_rent_log (return_user_id=0)
    //  2. 寫 localStorage pending_coupon_claim (讓 /discount/ecommerce 接手領券)
    //  3. 透過 LIFF URL + query param 跳進 LINE app
    //  4. LIFF 內自動 native 登入後呼叫 bindUserRentLog 綁定
    setStopScan(true);
    try {
      // 優先用 ref:state 可能還沒 flush 到 closure(handleScan→findEpkId→此處全在同一 microtask 序),
      // 會造成 chs_id/svpt_id undefined → 後端 validation 失敗
      const chsIdForGuest = channelIdRef.current ?? channel_id;
      const svptIdForGuest = svptIdRef.current ?? svpt_id;
      const { data: resp } = await saveGuestRentLogs({
        epk_id: epkId.current,
        chs_id: chsIdForGuest,
        svpt_id: svptIdForGuest,
        ...returnPlace(),
      });
      const rentLogId = (resp as any)?.data?.claim_token;
      if (!rentLogId) {
        throw new Error('missing claim_token from saveGuestRentLogs');
      }

      // localStorage 是給同一個 browser context 的 /discount/ecommerce 讀的；
      // LINE app webview 讀不到這個 localStorage，所以也要透過 URL param 帶過去
      try {
        localStorage.setItem(
          'pending_coupon_claim',
          JSON.stringify({ user_rent_log_id: rentLogId, created_at: Date.now() })
        );
      } catch (err) {
        console.log('localStorage write failed', err);
      }

      // 全家 placeholder → 真實 store：避免 LIFF 回來後再次落到 fami99999
      const effectiveSalesChannel = salesChannelRef.current || 'other';
      const effectiveStoreId =
        storeId === 'fami99999' && storeIdRef.current && storeIdRef.current !== 'fami99999'
          ? storeIdRef.current
          : storeIdRef.current || storeId || '';
      const targetPath = effectiveStoreId
        ? `/return/${effectiveSalesChannel}/${effectiveStoreId}`
        : `/return`;

      const params = new URLSearchParams();
      params.set('pendingRentLog', String(rentLogId));
      params.set('fromGuest', '1');

      const liffId = process.env.REACT_APP_LIFFID || '';
      if (!liffId) {
        throw new Error('REACT_APP_LIFFID not configured');
      }
      // 先展示中繼按鈕,使用者點擊後才同步觸發 navigation — 確保 iOS Universal Link 能喚起 LINE app
      setPendingLineBind({
        url: `https://liff.line.me/${liffId}${targetPath}?${params.toString()}`,
        rentLogId,
        targetPath,
      });
      return;
    } catch (e: any) {
      console.error('saveGuestRentLogs failed', e);
      const errMsg: string = e?.response?.data?.errors ?? e?.message ?? '';
      // 今日已重複歸還（同一包裝當天只能記錄一次）
      if (errMsg === 'Returned twice on the same day.') {
        setErrorCheck(5);
        setManualErrorVisible(true);
        return;
      }
      console.error(formatApiError('saveGuestRentLogs', e));
      setErrorCheck(3);
      setManualErrorVisible(true);
      setStopScan(false);
      return;
    }
  };

  /**
   * 包裝掃描成功後的分流：
   *  - 未登入(訪客) → 彈 guestConfirmVisible dialog 做包裝編號二次確認,
   *    使用者按確認才呼叫 executeGuestReturn。
   *  - 已登入(會員) → 推到 step 2 + remindVisible「自己還/幫人還」dialog。
   */
  /**
   * 全家歸還:掃完包裝當下就記歸還成功,直接進「寄件編號 QRC」畫面
   * (done + fami_tage → FamiReturnQrc 掛載即向日翊要號、產 QRCode 給店員掃)。
   *
   * 刻意不走「確認歸還→歸還明細→社福贊助頁」與訪客的 LIFF-bind 跳轉 ——
   * 全家的重點是先把寄件 QRC 交出去,實際簽收由日翊回拋認定;領券留到 QRC 下方「完成」按鈕之後。
   */
  const completeFamiReturn = async () => {
    stepRef.current = 2;
    setStep(2);
    setStopScan(true);
    setFamiTage(true);
    const chsId = channelIdRef.current ?? channel_id;
    const svptId = svptIdRef.current ?? svpt_id;
    try {
      if (accessToken) {
        const { data } = await saveUserRentLogs(accessToken, 1, {
          // 同上:掃碼當下 state 還是舊值,訪客路徑用的就是 ref
          epk_id: epkId.current || epk_id,
          renter_id: renter_id,
          return_user_id: me?.id!,
          chs_id: chsId,
          svpt_id: svptId,
          return_type: 0,
          ...returnPlace(),
        });
        setUserRentLogs(data);
        setFamiIsRescan((data as any)?.is_rescan === true);
        const rentLogId =
          (data as any)?.userRentLog_id ||
          (data as any)?.data?.userRentLog_id ||
          (data as any)?.data?.user_rent_log_id;
        if (rentLogId) setFamiRentalLogId(Number(rentLogId)); // 帶給要號連退貨通訂單
        if (rentLogId) {
          try {
            localStorage.setItem(
              'pending_coupon_claim',
              JSON.stringify({ user_rent_log_id: rentLogId, created_at: Date.now() })
            );
          } catch (err) {
            console.log('localStorage write failed', err);
          }
          setPendingRentLogId(rentLogId);
        }
      } else {
        const { data: resp } = await saveGuestRentLogs({
          epk_id: epkId.current,
          chs_id: chsId,
          svpt_id: svptId,
          ...returnPlace(),
        });
        setFamiIsRescan((resp as any)?.is_rescan === true);
        const guestRentLogId =
          (resp as any)?.userRentLog_id || (resp as any)?.data?.user_rent_log_id;
        if (guestRentLogId) setFamiRentalLogId(Number(guestRentLogId)); // 帶給要號連退貨通訂單
        const claim = (resp as any)?.data?.claim_token;
        if (claim) {
          try {
            localStorage.setItem(
              'pending_coupon_claim',
              JSON.stringify({ user_rent_log_id: claim, created_at: Date.now() })
            );
          } catch (err) {
            console.log('localStorage write failed', err);
          }
          setPendingRentLogId(claim);
        }
      }
      // 存包裝編號:使用者從 QRC 點「找最近的全家」去地圖後,可用 ?resume=1 回到這張 QRC,不重跑流程
      try {
        sessionStorage.setItem('fami_resume_epk', epk_id);
      } catch (err) {
        console.log('sessionStorage write failed', err);
      }
      setDone(true); // → done 畫面(sponsor 預設 false)→ fami_tage → FamiReturnQrc
    } catch (e: any) {
      const errMsg: string = e?.response?.data?.errors ?? e?.message ?? '';
      const status: number | undefined = e?.response?.status;
      // 重複歸還、或短時間多次歸還被限流(429)→ 顯示中文「今日已重複歸還」,不要露出 429/英文
      if (duplicateReturnMessage(errMsg) || status === 429) {
        setErrorCheck(5);
        setManualErrorVisible(true);
        return;
      }
      console.error(formatApiError('completeFamiReturn', e));
      setErrorCheck(3);
      setManualErrorVisible(true);
    }
  };

  const handlePackageFound = async () => {
    // 全家:掃完包裝直接記歸還成功並顯示寄件 QRC,不走確認/社福/LIFF-bind 中繼
    if (salesChannelRef.current === 'fami' || fami_tage) {
      await completeFamiReturn();
      return;
    }

    const loggedIn = !!accessToken;

    if (!loggedIn) {
      // 訪客:先停相機 + 彈確認視窗,使用者在 dialog 按確認才真的送 saveGuestRentLogs
      setStopScan(true);
      setGuestConfirmVisible(true);
      return;
    }

    // 會員流程（已登入）
    stepRef.current = 2;
    setRemindVisible(true);
    fetchEpkType();
  };

  // LIFF webview 有時不會主動觸發系統權限提示就直接拋 NotAllowedError;
  // 顯式呼叫 getUserMedia 能強制觸發提示。拿到 stream 立刻釋放,避免佔住相機讓 QrReader 抓不到。
  const requestCameraPermission = async (): Promise<boolean> => {
    try {
      if (!navigator?.mediaDevices?.getUserMedia) return false;
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: { ideal: 'environment' } },
      });
      stream.getTracks().forEach((t) => t.stop());
      cameraRetryCountRef.current = 0;
      setShouldRenderCamera(false);
      setTimeout(() => setShouldRenderCamera(true), 200);
      return true;
    } catch (err: any) {
      console.error('[camera retry]', err?.name, err?.message);
      reportCameraError(err);
      return false;
    }
  };

  // 包一層 try/catch:任何意外(例如 liff 還沒 init 讀 isInClient 噴錯)都不能讓相機錯誤處理炸掉
  const reportCameraError = (err: any) => {
    try {
      logCameraError({
        err_name: err?.name ?? 'UnknownError',
        err_message: err?.message ?? '',
        user_agent: navigator?.userAgent,
        is_in_liff: typeof liff?.isInClient === 'function' ? liff.isInClient() : undefined,
        step: stepRef.current,
        retry_count: cameraRetryCountRef.current,
        page_url: typeof window !== 'undefined' ? window.location.href : undefined,
        referrer: typeof document !== 'undefined' ? document.referrer : undefined,
      });
    } catch {
      // 一切吞掉,觀察用 log 不能影響歸還
    }
  };

  // 全家(通路已固定、不需掃歸還點 QR):fami99999 placeholder 已能取得 channel/svpt,
  // 相機掛掉時只差手動輸入包裝編號即可完成歸還,不必繞回 LINE 官方帳號(外部 Safari 會相機再掛 → 死循環)。
  const isFamiFlow = (): boolean => {
    try {
      return (
        salesChannelRef.current === 'fami' ||
        fami_tage === true ||
        fromFami ||
        (typeof window !== 'undefined' && window.location.pathname.includes('fami99999'))
      );
    } catch {
      return false;
    }
  };

  // PG-188 相機錯誤時要給哪種手動逃生口:
  //   全家 / 已過歸還點(step>=1、通路已定)→ 'package'(手動輸入包裝編號)
  //   非全家 step 0(還沒定歸還點)→ 'pickPoint'(GPS 手動選歸還點)
  const cameraManualMode = (): 'package' | 'pickPoint' => {
    if (isFamiFlow()) return 'package';
    if (stepRef.current >= 1 || (salesChannelRef.current && storeIdRef.current)) return 'package';
    return 'pickPoint';
  };

  // 相機錯誤對話框的手動逃生口 dispatch:關錯誤框後依 mode 開對應 Modal。
  const onCameraManualAction = () => {
    const mode = cameraManualMode();
    setManualErrorVisible(false);
    setErrorCheck(0);
    errorCheckRef.current = 0;
    cameraRetryCountRef.current = 0;
    if (mode === 'pickPoint') {
      // 非全家:先確保有定位再開歸還點清單(選完點 → onReturnPointPicked → step 1)
      if (!gpsCheck) getLocation();
      setReturnPointPickerVisible(true);
      return;
    }
    // 通路已定:直接進包裝編號輸入(step 1),走既有已驗證手動路徑
    stepRef.current = 1;
    setStep(1);
    setManualVisible(true);
  };

  // 非全家歸還點選好:沿用 onManualConfirm(step 0)那條 — 由 chs_short_code/store_id 設 channel/svpt → step 1。
  const onReturnPointPicked = () => {
    setReturnPointPickerVisible(false);
    stepRef.current = 0;
    setStep(0);
    // setStep(0) 這個 tick 還沒 flush,onManualConfirm 讀 closure 的 step 會拿到舊值,
    // 明確把 0 傳進去才不會兩個分支都不進。
    onManualConfirm(undefined, 0);
  };

  const handleError = (err: any) => {
    const errName: string = err?.name ?? 'UnknownError';
    const detail = `${errName}: ${err?.message ?? ''}`;
    console.error('[camera]', detail);
    reportCameraError(err);

    // NotAllowedError：使用者拒絕或系統封鎖相機，無法自動恢復，必須引導去設定
    // 已達重試上限：同樣跳出對話框讓使用者改用手動輸入
    if (errName === 'NotAllowedError' || cameraRetryCountRef.current >= 2) {
      cameraRetryCountRef.current = 0;
      errorCheckRef.current = 1;
      setErrorCheck(1);
      try {
        setManualErrorIsInLiff(typeof liff?.isInClient === 'function' ? liff.isInClient() : false);
      } catch {
        setManualErrorIsInLiff(false);
      }
      setManualErrorInLineApp(/\bLine\//i.test(navigator?.userAgent || ''));
      setManualErrorMode(cameraManualMode());
      setManualErrorVisible(true);
      return;
    }

    // 可自動恢復的錯誤，靜默 retry：
    //   NotReadableError  → 前一個 stream 尚未釋放，等久一點 (2s)
    //   OverconstrainedError → constraints 不符，重試時 library 會用較寬鬆的 ideal
    //   AbortError        → 初始化被打斷（捲動 / 背景切換），短暫等待即可
    cameraRetryCountRef.current += 1;
    const retryDelay = errName === 'NotReadableError' ? 2000 : 800;
    setCameraRetrying(true);
    setShouldRenderCamera(false);
    setTimeout(() => {
      setShouldRenderCamera(true);
      setCameraRetrying(false);
    }, retryDelay);
  };
  const handleScan = async (result: any) => {
    if (flowNoticeOpenRef.current) return; // 歸還流程教學彈窗還開著,先不處理掃描結果
    if (result) cameraRetryCountRef.current = 0; // 掃到任何內容代表相機正常，重置 retry 計數
    /* eslint-disable */
    // 20230112 wilson add 限制step1 相機掃的URL規格
    // const returnSpotRegex =
    //   /https:\/\/liff\.line\.me\/(?<liffId>[^\/\s]+)\/return\/(?<salesChannel>[^\/\s]+)\/(?<storeId>[^\/\s]+)/;
    // const lihiRegex = /https:\/\/lihi1\.com\/(?<shortUrl>[^\/\s]+)/;
    const returnSpotRegex =
          /https:\/\/liff\.line\.me\/([^\/\s]+)\/return\/([^\/\s]+)\/([^\/\s]+)/;
    const lihiRegex = /https:\/\/lihi1\.com\/([^\/\s]+)/;
    /* eslint-enable */
    
    if (result && !stopScan) {
      if (stepRef.current === 0) {
        // const [,shortUrl] 只會取到 hash, const [shortUrl]會包含 https 跟網域
        const [shortUrl] = result.match(lihiRegex) || []; // 要加 || [] 21.12.14 SCH
        shortUrlRef.current = shortUrl; // 21.12.15 Mike
        // console.log("lihi shortUrl: " + shortUrlRef.current);
        // Lihi shortUrl
        const [, , salesChannel, storeId] = result.match(returnSpotRegex) || [];
        if (shortUrl) {
          shortUrlRef.current = shortUrl; // 21.12.15 Mike
          // 舊版靠 lihi_url 反查通路,但新版端點只收 chs_short_code/store_id,
          // 這裡沒有通路代號可送 —— 打出去必定是必填參數落空的 422。
          // 直接請使用者改掃歸還點 QR,不要送一個註定失敗的請求。
          setStopScan(true);
          setErrorCheck(6);
          setManualErrorVisible(true);
        } else if (storeId === "fami99999") {
          // 20230113 wilson add fami port 進入連結 // 鏡頭掃描進入
          getLocation(); // 20230112 wilson add
          setFamiFrom(Math.random()); // 隨機數，讓全家能自動抓取最近店家
          setTimeout(() => {
            stepRef.current = 0;
            setStep(0);
            setManualVisible(true);
          }, 1500);
        } else if (salesChannel && storeId) {
          salesChannelRef.current = salesChannel;
          storeIdRef.current = storeId;
          // 已取得 通路代號(salesChannel) 與 商店ID (sotreID)
          fetchChannelStoreBySC(); // 21.12.11 SCH
        } else {
          // 掃錯：內容不是歸還點 QRC（可能是包裝編號或其他）→ 顯示防呆提示
          setStopScan(true);
          setErrorCheck(6);
          setManualErrorVisible(true);
        }
      }
      if (stepRef.current === 1) {
        // 包裝編號：純大寫字母 + 數字，長度 6-25
        const isPackageId = /^[A-Z0-9]{6,25}$/.test(result);
        if (isPackageId) {
          // 擋住掃到同一碼重複觸發,避免 findEpkId / handlePackageFound 被 race 打亂
          setStopScan(true);
          // 必須 await:後續 handlePackageFound 的非 momo guest 分支會讀 chs_id/svpt_id,
          // 沒這層 await 會在資料還沒載完就打 saveGuestRentLogs,失敗後落到 liff.login()
          if (!channelResolved()) {
            await fetchChannelStoreBySC();
          }
          if (!channelResolved()) {
            // 通路查不到就不能建歸還紀錄,中止避免落到 liff.login()。
            // 沒有通路代號代表使用者還沒掃歸還點,直接說「請先掃歸還點」比
            // fetchChannelStoreBySC 丟出的「參數錯誤」精準;而且相機要停住,
            // 否則下一個 decode 又會跑進來,變成連續失敗。
            if (!salesChannelRef.current) {
              setErrorCheck(6);
              setManualErrorVisible(true);
              return;
            }
            setStopScan(false);
            return;
          }
          epkId.current = result;
          const ok = await findEpkId();
          if (ok) {
            packageIdRef.current = result;
            await handlePackageFound();
          } else {
            // findEpkId 已彈錯誤視窗,但若使用者選擇繼續重掃,需讓相機再次運作
            setStopScan(false);
          }
        } else {
          // 掃錯：step 1 應該掃包裝編號，掃到其他東西（URL、亂碼）→ 防呆提示
          setStopScan(true);
          setErrorCheck(7);
          setManualErrorVisible(true);
        }
      }
    }
  };
  const onCurrentLocationConfirm = () => {
    stepRef.current = 1;
    setStep(1);
  };

  // 20230111 wilson add
  // forcedStep:呼叫端剛 setStep() 還沒 flush 時要明確指定,不能靠 closure 裡的 step
  //（onReturnPointPicked 就是同一個 tick 內 setStep(0) 後直接呼叫）。
  const onManualConfirm = async (data?: ServicePointsData | string, forcedStep?: number) => {
    const currentStep = forcedStep ?? step;
    if (currentStep === 0) {
      // 沒選到歸還點就送出,chs_short_code 是後端必填 → 422。留在原畫面讓使用者重選。
      if (!chs_short_code) {
        setManualErrorVisible(true);
        setErrorCheck(3);
        return;
      }
      salesChannelRef.current = chs_short_code;
      storeIdRef.current = store_id; // 21.12.24 SCH
      shortUrlRef.current = "noUrl"; // 22.02.09 SCH
      // 必須 await 且確認成功:查詢失敗還推進到 step 1,使用者會在輸入包裝編號時
      // 才撞上同一個錯誤,而那時已經沒有回頭選歸還點的入口。
      const ok = await fetchChannelStoreBySC(); // 21.12.24 SCH
      if (!ok) {
        return;
      }
      stepRef.current = 1;
      setManualVisible(false);
      setStep(1);
    }
    if (currentStep === 1) {
      // 必須 await：channelIdRef/svptIdRef 是 saveGuestRentLogs 必要參數，
      // 不等 fetch 完成直接跑 handlePackageFound 會拿到 undefined → 422 → liff.login() fallback
      if (!channelResolved()) {
        await fetchChannelStoreBySC();
      }
      if (!channelResolved()) {
        // fetchChannelStoreBySC 失敗（已顯示 errorCheck=3 dialog），中止
        return;
      }
      packageIdRef.current = epk_id;
      // 手動輸入也要打 chkEpkId 取得 customer，然後走同一份分流邏輯
      epkId.current = epk_id;
      const ok = await findEpkId();
      setManualVisible(false);
      if (ok) {
        await handlePackageFound();
      }
    }
  };
  
  // 20230111 wilson add
  const onManualNoGPSConfirm = (data?: ServicePointsData | string) => {
    if (step === 0) {
      salesChannelRef.current = chs_short_code;
      storeIdRef.current = store_id; 
      shortUrlRef.current = "noUrl"; 
      fetchChannelStoreBySC(); 
      stepRef.current = 1;
      setManualNoGPSVisible(false);
      setStep(1);
    }
    if (step === 1) {
      if (!channel_name || !svpt_name) {
        // 22.02.09 SCH
        fetchChannelStoreBySC();
      }
      packageIdRef.current = epk_id;
      fetchEpkType(); 
      stepRef.current = 2;
      setManualVisible(false);
      // if (guest_path) {
      //   console.log('bbbbb')
      //   return;
      // }
      setRemindVisible(true);
    }
  };

  const repeatfn = () => {
    setRepeatVisible(false)
    navigate('/rent');
  }

  // 歸還完成 → 寫 localStorage 領券憑證 → 播 2s 過場動畫。
  // 全家「包裝交給店員了」與測試站「模擬店員掃描」兩顆按鈕共用,避免完成邏輯重複。
  const advanceToReturnComplete = () => {
    const rentLogId =
      (userRentLogs as any)?.userRentLog_id ||
      (userRentLogs as any)?.data?.userRentLog_id ||
      (userRentLogs as any)?.data?.user_rent_log_id;
    if (rentLogId) {
      try {
        localStorage.setItem(
          'pending_coupon_claim',
          JSON.stringify({
            user_rent_log_id: rentLogId,
            created_at: Date.now(),
          })
        );
      } catch (err) {
        console.log('localStorage write failed', err);
      }
      setPendingRentLogId(rentLogId);
    }
    setReturnJustCompletedVisible(true);
  };

  return (
    <>
      <Helmet title="歸還" />
      {sponsor ? (
        <div className={styles.return}>
          <div className={styles.sponsor}>
            <div className={styles.mainpic}>
              {/* <img
                  style={{ width: 300, height: 300, left: 52, top: 152 }}
                  src={SponserAcerPNG}
                  alt="PNG"
                /> */}
              {/* {srandom === 0 ? <SponserAcerSVG /> : <SponserDBSSVG />} */}
              {/* <SponserAcerSVG /> */}
              {srandom === 0 ? 
              <img
                  style={{ width: 300, height: 300, left: 52, top: 152 }}
                  src={SponserAcerPNG}
                  alt="PNG"
                />
              : 
              <img
                  style={{ width: 300, height: 300, left: 52, top: 152 }}
                  src={SponserDBSPNG}
                  alt="PNG"
                />
              }
            </div>
            <div className={styles.maincontent}>
              <div className={styles.sponsorcon}>
                <p>
                  <span>PackAge+ </span>
                  與社福基金會合作包裝清潔
                </p>
                <p>提供弱勢朋友穩定的工作機會與收益！</p>
              </div>
              <div className={styles.sponsortag}>
                <SponserStarSVG />
                <p>
                  本次由{" "}
                  <span className={styles.tagUnder}>
                    {srandom === 0 ? "宏碁股份有限公司" : "星展銀行"}
                    {/* 宏碁股份有限公司 */}
                  </span>{" "}
                  響應贊助
                </p>
                <SponserStarSVG />
              </div>
              <div
                className={styles.button}
                onClick={() => {
                  setSponsor(false);
                }}
              >
                下一步{" "}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.return}>
          {done ? (
            <div className={styles.result}>
              {/* 20230112 wilson add */}
              {fami_tage ? (
                <img
                  style={{ width: 360, height: 41.84, left: 7, top: 96 }}
                  src={FamiPackagePNG}
                  alt="PNG"
                />
              ) : (
                <p></p>
              )}
              {/* 20230112 wilson add */}
              {fami_tage ? (
                // PG-147 全家歸還:向日翊建退貨通取寄件編號,產 QRCode 給店員掃。
                // 傳真實會員姓名/手機當寄件人 → 機台方式(寄件編號+手機)才對得上;
                // 未登入則後端 fallback 預設寄件人,店員掃 QR 仍可交件。
                // 建單失敗時 FamiReturnQrc 內部會顯示錯誤 + 重試,不影響已完成的歸還。
                <FamiReturnQrc
                  epkId={epk_id}
                  rentalLogId={famiRentalLogId}
                  isRescan={famiIsRescan}
                  senderName={me?.realname || me?.nickname || undefined}
                  senderPhone={me?.mobile_number || undefined}
                />
              ) : returnType === "box" ? (
                <ReturnBoxSVG />
              ) : (
                <ReturnStaffSVG />
              )}

              {fami_tage ? (
                // 全家:寄件 QR 畫面即終點(顧客拿去 FamiPort 交件,歸還成功/發券由日翊 B02 回拋 server 端觸發)。
                // 保留「領取優惠券→官方 LINE」按鈕:誘因讓匿名 momo 客綁定記名 + 導去官方 LINE。券要交件確認後約 2-3 個工作天才有。
                <>
                  <p
                    style={{
                      margin: '16px auto 6px',
                      fontSize: 13,
                      fontWeight: 700,
                      color: '#3db270',
                      textAlign: 'center',
                      maxWidth: 300,
                      lineHeight: 1.5,
                    }}
                  >
                    ✅ 交件確認後約 2-3 個工作天,優惠券會發放
                    <br />
                    可至配客嘉 LINE 領取
                  </p>
                  <div
                    className={styles.button}
                    style={{ marginTop: 10, marginBottom: 10 }}
                    onClick={() => {
                      // 帶著這次歸還的 claim_token 進 LIFF 領券頁,而不是只丟到官方帳號首頁。
                      //
                      // 全家掃完包裝時使用者多半還沒登入(/return 刻意不強制登入),歸還會落成
                      // 匿名的訪客紀錄 —— 系統不知道他是誰,交件回拋進來時就沒有對象可以推播、
                      // 也無從判斷該不該發券。點「領取優惠券」是使用者自己要身分的時刻,
                      // 在這裡把歸還綁回會員最自然。沒有 token 時才退回官方帳號首頁。
                      // fami=1:告訴領券頁這是全家流程 —— 綁定後要推引導訊息並關回聊天畫面,
                      // 而不是留在券頁(全家的券要等交件確認,現在留在頁上只會看到空清單)。
                      //
                      // 已登入會員沒有 claim_token(掃描當下就綁好了),要改用歸還單號直接請後端推,
                      // 否則按了按鈕永遠收不到引導訊息 —— 9/2 實測整天 0 次呼叫就是這個原因。
                      if (pendingRentLogId) {
                        window.location.href = `${LIFF_COUPON_CLAIM_URL}?user_rent_log_id=${pendingRentLogId}&fami=1`;

                        return;
                      }
                      if (famiRentalLogId) {
                        sendFmeClaimGuide({ rentalLogId: Number(famiRentalLogId) });
                      }
                      // 不等推播回應:推不推得出去都不該卡住使用者回 LINE
                      setTimeout(() => {
                        window.location.href = LINE_OFFICIAL_URL;
                      }, 400);
                    }}
                  >
                    <div>
                      <span>領取優惠券</span>
                    </div>
                    <ArrowSVG />
                  </div>
                  <p
                    style={{
                      margin: '4px auto 12px',
                      fontSize: 12,
                      color: '#888',
                      textAlign: 'center',
                      maxWidth: 300,
                      lineHeight: 1.5,
                    }}
                  >
                    點選後將引導您加入配客嘉官方 LINE,以便進行歸戶領取優惠券喔!
                  </p>
                  {IS_TEST_SITE && (
                    <button
                      type="button"
                      onClick={async () => {
                        try {
                          await simulateFmeReturnship({ epk_id });
                          setFamiSimDoneVisible(true);
                        } catch (err) {
                          console.log('simulate on test failed', err);
                        }
                      }}
                      style={{
                        margin: '10px auto 0',
                        display: 'block',
                        padding: '8px 18px',
                        background: '#f0ad4e',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 20,
                        fontSize: 13,
                        fontWeight: 600,
                        cursor: 'pointer',
                        lineHeight: 1.5,
                      }}
                    >
                      模擬交件
                      <span style={{ display: 'block', fontSize: 11, fontWeight: 400 }}>
                        (只有測試站會顯示該按鈕)
                      </span>
                    </button>
                  )}
                  {/* LINE IAB / Safari 底部工具列會浮在頁面上蓋住最後的按鈕,墊高讓按鈕捲得出來 */}
                  <div style={{ height: 'calc(96px + env(safe-area-inset-bottom, 0px))' }} />
                </>
              ) : (
                <div
                  className={styles.button}
                  onClick={advanceToReturnComplete}
                >
                  <div>
                    <span>
                      {returnType === "box"
                        ? "包裝投進歸還箱了"
                        : "包裝交給店員了"}
                    </span>
                  </div>
                  <ArrowSVG />
                </div>
              )}
            </div>
          ) : (
            <div className={styles.cameraContainer} >
              
              <div className={styles.cameraBorder}>
                <div className={styles.scannerContainer}>
                    <div className={styles.scannerInner} />
                </div>
                <div className={styles.qrWrap}>
                  {/*
                    LIFF 重新載入時（hasPendingScan=true）不要 render 相機：
                    (a) 避免重複跳「允許使用相機」權限 prompt — 使用者已經在外部瀏覽器掃完了
                    (b) 動畫 / 歸還完成 Dialog 顯示時也不該浪費資源開相機
                  */}
                  {cameraRetrying && (
                    <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.5)', color: '#fff', fontSize: 14 }}>
                      相機重新啟動中…
                    </div>
                  )}
                  {shouldRenderCamera
                    && !hasPendingScan
                    && !returnJustCompletedVisible
                    && !returnCompleteVisible && (
                    <QrReaderAny
                      className={styles.reactQrReader}
                      facingMode="environment"
                      constraints={{ facingMode: { ideal: 'environment' } }}
                      delay={300}
                      onError={handleError}
                      onScan={handleScan}
                      showViewFinder={false}
                    />
                  )}
                </div>
              </div>    
              
              {/* <QrReader
                delay={300}
                onError={handleError}
                onScan={handleScan}
                style={{ width: "100%", height: "100%" }}
                showViewFinder
                containerStyle={{
                  width: "100%",
                  height: "100%",
                  position: "relative",
                  overflow: "hidden",
                }}
                // constraints={{
                //   video: {
                //     width: { ideal: 1280 },
                //     height: { ideal: 720 },
                //     facingMode: { exact: 'environment' }
                //   }
                // }}
                viewFinder={
                  <div className={styles.scannerContainer}>
                    <div className={styles.scannerInner} />
                  </div>
                }
              /> */}
              {step === 1 && (
                <div className={styles.selectedStore}>
                  {/* <ShopSVG /> */}
                  <span>
                    {channel_name}-{svpt_name}
                  </span>
                </div>
              )}
              {step === 2 && (
                <div className={styles.selectedStore}>
                  {/* <ShopSVG /> */}
                  <span>{epk_id}</span>
                </div>
              )}
            </div>
          )}
          <div className={styles.footer}>
            {/* 全家寄件 QRC 畫面是流程終點,底部 STEP 進度條在此已無意義,藏掉省空間 */}
            {!(done && fami_tage) && <Stepper step={step} />}

            {/*
              無法掃描請點我 顯示規則（對齊正式機）：
              - step 1 (掃包裝編號)：常駐顯示（不需要先錯一次）
              - step 0 (掃歸還點)：不顯示
              其他情境（LIFF 還原 / 完成彈窗 / done）隱藏避免干擾。
            */}
            {step === 1
              && !hasPendingScan
              && !remindVisible
              && !returnCompleteVisible
              && !returnJustCompletedVisible
              && !done && (
                <button
                  className={styles.btn}
                  onClick={() => {
                    // PG-88: ManualModal 是全家專用挑店畫面,無論入口 URL 是否帶 ?from=fami,
                    // 打開都需要 GPS 才能列「離我最近」。掃包裝 QR 進來的 URL 不帶 ?from=fami,
                    // 舊 fromFami gate 會跳過 getLocation,造成 Lynn 回報的全家抓不到最近店家。
                    if (!gpsCheck) {
                      getLocation();
                    }
                    setManualVisible(true);
                  }}
                >
                  無法掃描請點我
                </button>
              )}
          </div>
        </div>
      )}
      <Dialog
        // visible={repeatVisible}
        visible={repeatVisible}
        
        // visible={true}
        onConfirm={()=>{repeatfn()}}
        message={
          <div className={styles.dialogHeader}>
            <h5>提醒</h5>
            <p>
              {/* 您輸入的包裝編號已在系統中
              <br />
              成功歸還，請將包裝交給店員
              <br />
              或投入歸還箱。
              <br />
              <br /> */}
              {mess}
              {/* 若您取得多個同樣包裝編號的循環包裝，
              <br />
              請稍候一分鐘再試。 */}
              <br />
            </p>
            {/* <button
              className={styles.okButtonStyles2}
              onClick={() => {
                setRepeatVisible(false)
              }}
            >
              <span>我知道了</span>
            </button> */}
          </div>
        }
        // showOk={false}
        showOk={true}
        // okText="我知道了"
      />
      {/* 測試站「模擬交件」結果提示 — 取代 window.alert,與站內其他彈窗同設計 */}
      <Dialog
        visible={famiSimDoneVisible}
        onConfirm={() => setFamiSimDoneVisible(false)}
        okText="確定"
        message={
          <div className={styles.dialogHeader}>
            <h5>模擬交件完成</h5>
            <p>
              已模擬日翊交件回拋(B02),
              <br />
              可至後台查看包材的交寄資料。
            </p>
          </div>
        }
      />
      <Dialog
        visible={remindVisible}
        onConfirm={onConfirm}
        onCancel={onCancel}
        message={
          <div className={styles.dialogHeader}>
            <h5>提醒</h5>
            <p>
              請問您是自己歸還，
              <br />
              還是幫家人、朋友歸還包裝呢？
              <br />
            </p>
            <p>包裝編號：{epk_id}</p>
          </div>
        }
        cancelText="我幫別人還"
        okText="我幫自己還"
        cancelable
      />
      {/* 訪客包裝編號二次確認(momo 免登入 / 非 momo LIFF-bind 共用)—
          Lynn 要求:所有歸還通路(含訪客)都要有包裝編號確認,避免掃錯就直接建歸還紀錄。
          會員有 remindVisible 同時問「自己還/幫人還」,訪客沒會員身份所以只做純編號確認。 */}
      <Dialog
        visible={guestConfirmVisible}
        onConfirm={() => {
          setGuestConfirmVisible(false);
          executeGuestReturn();
        }}
        onCancel={() => {
          // 使用者覺得編號錯,取消 → 恢復相機讓他重新掃
          setGuestConfirmVisible(false);
          setStopScan(false);
          epkId.current = '';
          packageIdRef.current = '';
        }}
        message={
          <div className={styles.dialogHeader}>
            <h5>確認歸還</h5>
            <p>
              請確認包裝編號是否正確,
              <br />
              確認後即完成歸還
            </p>
            <p>包裝編號:{epkId.current}</p>
          </div>
        }
        cancelText="重新掃描"
        okText="確認歸還"
        cancelable
      />
      <Dialog
        visible={detailVisible}
        onConfirm={onDetailConfirm}
        message={
          <div className={styles.detailDialogHeader}>
            <h5>包裝歸還明細</h5>
            <div className={styles.content}>
              <div>
                <span>歸還時間</span>
                {/* <span>{returnTime.current}</span> */}
                <span>{epkType?.date_time}</span>
              </div>
              <div>
                <span>歸還地點</span>
                {/* <span>{salesChannelRef.current}</span> */}
                <span>
                  {channelStores?.channel_name}-{channelStores?.svpt_name}
                </span>
              </div>
              <div>
                <span>包裝類別</span>
                {/* <span>{packageIdRef.current}</span> */}
                <span>{epkType?.type_name}</span>
              </div>
              {state && state.phone && (
                <>
                  <div>
                    <span>歸還者</span>
                    {/* <span>{state.phone}</span> */}
                    <span>
                      {me!.realname !== "" ? me!.realname : me!.mobile_number}
                    </span>
                  </div>
                  <div>
                    <span>使用者</span>
                    <span>{state.phone}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        }
        okText="我知道了"
        okButtonStyles={styles.okButtonStyles}
      />
      <Dialog
        visible={currentLocationlVisible}
        onConfirm={onCurrentLocationConfirm}
        onBackdropClick={() => {
          setCurrentLocationVisible(false);
        }}
        message={
          <div className={styles.currentLocation}>
            <p className={styles.title}>您目前在</p>
            <p className={styles.shopName}>
              {channelStores?.channel_name}
              {channelStores?.svpt_name}
            </p>
            <div>
              <img
                style={{ maxWidth: "100%", maxHeight: "100%" }}
                src={LIFF20GIF}
                alt="gif"
              />
            </div>
            <div className={styles.tip}>
              <p>接下來請掃描</p>
              <p>「包裝編號」QR Code</p>
            </div>
            <button
              className={styles.okButtonStyles}
              onClick={() => {
                setCurrentLocationVisible(false);
                onCurrentLocationConfirm();
              }}
            >
              <div className={styles.otherComfirm} style={{ fontSize: "18px", color: "green" }}>
                <span className={styles.com1}>「確認」</span>
                <span className={styles.com2}>
                  <ArrowSVG />
                </span>
              </div>
            </button>
          </div>
        }
        showOk={false}
      />
      {/* 非 momo LIFF-bind 新流程的 2 秒 A1 過場動畫
          動畫結束時：關掉動畫 + 開領券 Dialog */}
      {returnJustCompletedVisible && (
        <ReturnCompleteAnimation
          onFinish={() => {
            setReturnJustCompletedVisible(false);
            setReturnCompleteVisible(true);
          }}
        />
      )}

      {/* 掃描成功 → 中繼按鈕 → LIFF 登入
          iOS Universal Link 只認 user gesture 同步 navigation,QR onScan 的 async callback
          直接 window.location.href 會被當一般網頁開、不跳 LINE app,造成使用者卡白畫面。 */}
      {pendingLineBind && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            background: 'rgba(255,255,255,0.98)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 12 }}>
            包裝掃描成功
          </div>
          <div style={{ fontSize: 15, color: '#555', marginBottom: 32, lineHeight: 1.5 }}>
            點擊下方按鈕前往 LINE 完成登入,
            <br />
            系統會幫您自動綁定此次歸還並領取優惠券
          </div>
          <button
            className={styles.actionButton}
            style={{ maxWidth: 320 }}
            onClick={() => {
              // 寫 sessionStorage 作為「真的按下按鈕了、要走 LINE 流程」的訊號,
              // 只有按下之後才可能觸發救援按鈕(從 liff.line.me 失敗回來的情境)。
              // 不按就不寫 — 避免使用者看了中繼頁卻關 tab,sessionStorage 殘留污染下個歸還流程。
              try {
                sessionStorage.setItem(
                  'pending_line_bind',
                  JSON.stringify({
                    rentLogId: pendingLineBind.rentLogId,
                    targetPath: pendingLineBind.targetPath,
                    created_at: Date.now(),
                  })
                );
              } catch (err) {
                console.log('sessionStorage write failed', err);
              }
              // 同步觸發 — 在 user gesture 內 assign location.href,iOS 才會走 Universal Link 開 LINE app
              window.location.href = pendingLineBind.url;
              // 跳 LINE 後,把底層網頁導回 /rent;使用者若切回瀏覽器 tab 就不會卡在中繼頁感到困惑
              setTimeout(() => {
                navigate('/rent', { replace: true });
              }, 800);
            }}
          >
            前往 LINE 完成歸還
          </button>
          <div style={{ fontSize: 12, color: '#999', marginTop: 20 }}>
            若未自動跳轉 LINE,請確認 LINE 已安裝並重新點擊
          </div>
        </div>
      )}

      {/* 救援按鈕 — liff.line.me 沒成功喚起 LINE app、被 redirect 回 endpoint 且沒 session 時顯示
          使用者點擊同步觸發 liff.login,跳 access.line.me 手動登入,登完帶 accessToken + pendingRentLog
          回來觸發 bind */}
      {showLoginFallback && fallbackRentLogId !== null && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            background: 'rgba(255,255,255,0.98)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 12 }}>
            需要登入 LINE 完成歸還
          </div>
          <div style={{ fontSize: 15, color: '#555', marginBottom: 32, lineHeight: 1.5 }}>
            未偵測到 LINE 登入狀態,
            <br />
            點擊下方按鈕登入 LINE 以完成歸還並領取優惠券
          </div>
          <button
            className={styles.actionButton}
            style={{ maxWidth: 320 }}
            onClick={() => {
              try {
                const params = new URLSearchParams();
                params.set('pendingRentLog', String(fallbackRentLogId));
                params.set('fromGuest', '1');
                const redirectUri = `${window.location.origin}${fallbackTargetPath}?${params.toString()}`;
                // 同步 user gesture 觸發 liff.login → 跳 access.line.me 手動登入
                liff.login({ redirectUri });
                // 跳 LINE 後,把底層網頁導回 /rent,避免使用者切回瀏覽器 tab 還停在救援頁
                setTimeout(() => {
                  navigate('/rent', { replace: true });
                }, 800);
              } catch (e) {
                console.error('[liff fallback] login failed', e);
              }
            }}
          >
            登入 LINE
          </button>
        </div>
      )}

      {/* 歸還完成共用彈窗（momo 免登入 / 會員登入兩條路線共用）
          取代舊的 bonus / freeGift 彈窗，引導到 /discount/ecommerce 領取優惠券 */}
      <ReturnCompleteDialog
        visible={returnCompleteVisible}
        rentLogId={pendingRentLogId}
        famiMode={fami_tage}
        onClose={() => setReturnCompleteVisible(false)}
      />
      <ManualModal
        visible={manualVisible}
        step={step}
        onConfirm={onManualConfirm}
        onClose={() => {
          setManualVisible(false);
        }}
      />
      <ManualModalNoGPS
        visible={manualNoGPSVisible}
        step={step}
        onConfirm={onManualNoGPSConfirm}
        onClose={() => {
          setManualNoGPSVisible(false);
        }}
      />
      <ManualError
        visible={manualErrorVisible}
        errorCheck={errorCheck}
        isInLiff={manualErrorIsInLiff}
        inLineApp={manualErrorInLineApp}
        manualMode={manualErrorMode}
        onManualAction={onCameraManualAction}
        onRequestCameraPermission={requestCameraPermission}
        onClose={() => {
          setManualErrorVisible(false);
          // 可在原頁重試的錯誤(掃錯 case 6、7 / 查無包裝 case 8 / 掃描參數錯誤 case 3):重置掃描狀態讓使用者繼續重掃
          if (errorCheck === 3 || errorCheck === 6 || errorCheck === 7 || errorCheck === 8) {
            setStopScan(false);
            setErrorCheck(0);
          }
          // 相機錯誤(case 1)：使用者點確定後重置狀態（retry 已由 handleError 自動處理）
          if (errorCheck === 1) {
            setErrorCheck(0);
          }
          // 今日已重複歸還(case 5)：關閉後讓使用者繼續掃下一個包裝
          if (errorCheck === 5) {
            setErrorCheck(0);
            setStopScan(false);
          }
        }}
      />
      <ReturnFlowNotice
        visible={flowNoticeVisible}
        onClose={() => {
          markReturnFlowNoticeSeen();
          flowNoticeOpenRef.current = false;
          setFlowNoticeVisible(false);
        }}
      />
      {/* PG-188 非全家相機掃不到歸還點 QR 時的手動選點(GPS 最近清單)→ 選完走 onManualConfirm(step0) */}
      <ReturnPointPicker
        visible={returnPointPickerVisible}
        onConfirm={onReturnPointPicked}
        onClose={() => setReturnPointPickerVisible(false)}
      />
    </>
  );
};

export default Return;
